import { IgrColumn } from "./igr-column";
import { GridCellEditStartedEventArgs as GridCellEditStartedEventArgs_internal } from "./GridCellEditStartedEventArgs";
var IgrGridCellEditStartedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellEditStartedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridCellEditStartedEventArgs.prototype.createImplementation = function () {
        return new GridCellEditStartedEventArgs_internal();
    };
    Object.defineProperty(IgrGridCellEditStartedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellEditStartedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridCellEditStartedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridCellEditStartedEventArgs.prototype, "column", {
        /**
         * Gets the column of the cell that started editing.
        */
        get: function () {
            if (this.i.a == null) {
                return null;
            }
            if (!this.i.a.externalObject) {
                var e = IgrColumn._createFromInternal(this.i.a);
                if (e) {
                    e._implementation = this.i.a;
                }
                this.i.a.externalObject = e;
            }
            return this.i.a.externalObject;
        },
        set: function (v) {
            v == null ? this.i.a = null : this.i.a = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellEditStartedEventArgs.prototype, "row", {
        /**
         * Gets the row index of the cell that started editing.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellEditStartedEventArgs.prototype, "item", {
        /**
         * Gets the row item.
        */
        get: function () {
            return this.i.item;
        },
        set: function (v) {
            this.i.item = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridCellEditStartedEventArgs;
}());
export { IgrGridCellEditStartedEventArgs };
//# sourceMappingURL=igr-grid-cell-edit-started-event-args.js.map
